import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApidataService } from '../services/apidata.service';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { APIUrl, RespCode } from '../enums/emums';
import { LoginResp, BalanceResp } from 'src/app/enums/apiResponse';
import { ApisessionService } from '../services/apisession.service';

@Component({
  selector: 'aditya-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  IsLoggedIn = false;
  LoginUserBalance = '0';
  Domain = '';
  LoginUserUBalance = '0';
  gettingBalanceSpinClass = "fa fa-refresh";
  isWalletToWallet = false;
  @Input() LoginDetail: any

  constructor(
    private router: Router,
    private apiData: ApidataService,
    private authService: AuthService,
    private apiSession: ApisessionService, private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    // this.apiData.getObjectData().subscribe((data: any) => {
    //   this.IsLoggedIn = data ? data.IsLoggedIn: false;
    // })
    // this.Domain = APIUrl.Domain;
  }

  ngAfterViewInit() {
    const trigger = document.getElementById('avatarTrigger');
    const dropdown = document.getElementById('userDropdown');

    let hideTimeout: any;

    const showDropdown = () => {
      clearTimeout(hideTimeout);
      dropdown!.style.display = 'block';
    };

    const hideDropdown = () => {
      hideTimeout = setTimeout(() => {
        dropdown!.style.display = 'none';
      }, 200); // gives user time to move from trigger to dropdown
    };

    if (trigger && dropdown) {
      trigger.addEventListener('mouseenter', showDropdown);
      trigger.addEventListener('mouseleave', hideDropdown);

      dropdown.addEventListener('mouseenter', showDropdown);
      dropdown.addEventListener('mouseleave', hideDropdown);
    }
  }


  // ngAfterViewInit() {
  //   const trigger = document.getElementById('avatarTrigger');
  //   const dropdown = document.getElementById('userDropdown');

  //   if (trigger && dropdown) {
  //     trigger.addEventListener('mouseenter', () => {
  //       dropdown.style.display = 'block';
  //     });

  //     trigger.addEventListener('mouseleave', () => {
  //       setTimeout(() => {
  //         dropdown.style.display = 'none';
  //       }, 300); // delay for smoother UI
  //     });

  //     dropdown.addEventListener('mouseenter', () => {
  //       dropdown.style.display = 'block';
  //     });

  //     dropdown.addEventListener('mouseleave', () => {
  //       dropdown.style.display = 'none';
  //     });
  //   }
  // }


  navigaetToRoute(routename: string) {
    this.router.navigate(["/" + routename]);
  }

  changeMenuLayout(value: any) {
    // this.apiData.setHeaderState(value);
    this.apiData.isMenuChange$.next(true);
    this.updateView()
    this.cdr.detectChanges();
  }

  gotoLogin() {
    localStorage.setItem('tabId', JSON.stringify(0))
    this.apiData.gotoPage('login.html');
    localStorage.setItem('isMobile', 'false')
  }

  gotosignup() {
    localStorage.setItem('tabId', JSON.stringify(0))
    this.apiData.gotoPage('signup.html');
    localStorage.setItem('isMobile', 'false')
  }

  updateView() {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }
}
